import { ConnectionStringModel } from './connection-string.model';

export class InfrastructureModel {
    /**
     * Connection key name
     */
   // public Connections: ConnectionStringModel;
   public Connections: any;
}